import { NgClass, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DisplayValidationErrorsDirective, IPrivacyForm } from '@curbnturf/form-helpers';
import { PrivacyValidator } from '@curbnturf/host-forms';

@Component({
  selector: 'curbnturf-privacy-form',
  templateUrl: './privacy-form.component.html',
  styleUrls: ['./privacy-form.component.scss'],
  standalone: true,
  imports: [NgIf, NgClass, FormsModule, ReactiveFormsModule, DisplayValidationErrorsDirective],
})
export class PrivacyFormComponent {
  @Input() privacyForm: FormGroup<IPrivacyForm>;

  privacyError: string | undefined;

  get secluded(): FormControl<boolean | null> | undefined {
    if (this.privacyForm) {
      return this.privacyForm.get('secluded') as FormControl<boolean | null>;
    }

    return;
  }

  get home(): FormControl<boolean | null> | undefined {
    if (this.privacyForm) {
      return this.privacyForm.get('home') as FormControl<boolean | null>;
    }

    return;
  }

  get neighbor(): FormControl<boolean | null> | undefined {
    if (this.privacyForm) {
      return this.privacyForm.get('neighbor') as FormControl<boolean | null>;
    }

    return;
  }

  get others(): FormControl<boolean | null> | undefined {
    if (this.privacyForm) {
      return this.privacyForm.get('others') as FormControl<boolean | null>;
    }

    return;
  }

  isolateSecluded(selectSecluded: boolean) {
    if (selectSecluded) {
      if (this.home) {
        this.home.setValue(false);
      }
      if (this.neighbor) {
        this.neighbor.setValue(false);
      }
      if (this.others) {
        this.others.setValue(false);
      }
    } else {
      if (this.secluded) {
        this.secluded.setValue(false);
      }
    }
  }

  public validate() {
    if (PrivacyValidator(this.privacyForm)?.invalidPrivacy) {
      this.privacyError = 'Please let us know how secluded your property is.';
    } else {
      this.privacyError = undefined;
    }
  }
}
